import axios from "../axiosConfig/axios";
export const Menus = {
    async getUserMenus(token) {
        return axios.get(`/menus`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })

    }
}